import { Heading, Image,Grid,Box, Flex } from '@chakra-ui/react'
import React from 'react'
import GitHubCalendar from 'react-github-calendar';
import "./github.css"
const Github = () => {
  return (
    <>
      <Heading color={"white"} margin={"20px"} >Github Activity</Heading>
      <Grid
          pt={["20px", "25px", "30px"]}
          templateColumns={"repeat(1,1fr)"}
          margin={"auto"}
          gap={3}
          justifyContent={"space-between"}
          alignItems={"center"}
          width={"90%"}
          border={"0px solid pink"}
        >
          <Box>
            <Flex
              flexDirection={["column", "column", "column", "row", "row"]}
              justifyContent={"space-around"}
              alignItems={"center"}
              m={"auto"}
              gap={[5, 6, 7, 8, 9]}
            >
              <Image
               boxShadow= "0 0 3px 3px rgba(0, 255, 0, 0.5)"
               borderRadius={7}
                alt="github-stats-card"
                id="github-stats-card"
                w={"100%"}
                src="https://github-readme-stats.vercel.app/api?username=Sachin-Kesarwani&bg_color=00000000&theme=vue-dark&show_icons=true&icon_color=2e9b56&border_color=2e9b56&text_color=ffffff"
              />

              <Image
               boxShadow= "0 0 3px 3px rgba(0, 255, 0, 0.5)"
               borderRadius={10}
                alt="github-streak-stats"
                id="github-streak-stats"
                w={"100%"}
                src="https://github-readme-streak-stats.herokuapp.com?user=Sachin-Kesarwani&background=00000000&theme=vue-dark&border=2e9b56&fire=2e9b56&currStreakNum=2e9b56&currStreakLabel=2e9b56&dates=ffffff"
              />
            </Flex>
          </Box>
          <Box >
            <Image
              boxShadow= "0 0 3px 3px rgba(0, 255, 0, 0.5)"
              borderRadius={10}
              alt="github-top-langs"
              id="github-top-langs"
              width={["100%", "100%", "100%", "100%", "100%"]}
              m={"auto"}
              src={
                "https://github-readme-stats.vercel.app/api/top-langs/?username=Sachin-Kesarwani&bg_color=00000000&layout=compact&theme=vue-dark&border_color=2e9b56&text_color=ffffff&card_width=600"
              }
            />
          </Box>
        </Grid>
        <Box
          border={"3px solid green"}
          borderRadius={"15px"}
          bg="none"
          width={"90%"}
          boxShadow= "0 0 3px 3px rgba(0, 255, 0, 0.5)"
          padding={[6, 8, 10]}
          margin={"auto"}
          mt={["10px", "10px", "20px"]}
          className="gitcal"
          // w={'80%'}
        >
          <GitHubCalendar
            username="Sachin-Kesarwani"
         
            textAlign={"center"}
            justifyContent={"center"}
            blockMargin={6}
            blockSize={20}
            hideColorLegend={true}
          />
          </Box>
     
    </>
   
  )
}

export default Github
